import { IInventorySettingsResponse } from '../models/types/settings/inventorySettings.types';

/**
 * Converts settings data from an inventory settings response object to a boolean value or numeric representation.
 *
 * @param {IInventorySettingsResponse} data - The inventory settings response data to be converted.
 * @param {boolean} toBoolean - Indicates whether to convert values to boolean (true/false) or numeric (1/0) representation.
 * @returns {Object} The converted settings data.
 */
export function convertSettingsData(data: IInventorySettingsResponse, toBoolean: boolean) {
  const convertedData = {
    sync_quantity_to_faire: toBoolean
      ? data?.sync_quantity_to_faire === 1
      : data?.sync_quantity_to_faire === true
        ? 1
        : 0,
    sync_product_status_to_faire: toBoolean
      ? data?.sync_product_status_to_faire === 1
      : data?.sync_product_status_to_faire === true
        ? 1
        : 0,
    sync_deleted_product_to_faire: toBoolean
      ? data?.sync_deleted_product_to_faire === 1
      : data?.sync_deleted_product_to_faire === true
        ? 1
        : 0,
    sync_similar_sku_in_wix: toBoolean
      ? data?.sync_similar_sku_in_wix === 1
      : data?.sync_similar_sku_in_wix === true
        ? 1
        : 0,
    exportable_price_to_faire: data?.exportable_price_to_faire,
    export_price_as_to_faire: data?.export_price_as_to_faire,
    conversion_rate_to_retail_price: data?.conversion_rate_to_retail_price,
    sync_faire_quantity_to_wix: toBoolean
      ? data?.sync_faire_quantity_to_wix === 1
      : data?.sync_faire_quantity_to_wix === true
        ? 1
        : 0,
    sync_similar_sku_in_faire: toBoolean
      ? data?.sync_similar_sku_in_faire === 1
      : data?.sync_similar_sku_in_faire === true
        ? 1
        : 0,
    exportable_price_to_wix: data?.exportable_price_to_wix,
  };

  return convertedData as any;
}
